import { Icon } from '@/components/ui/Icon';
import { useSipStore } from '@/personas/agent/stores/sipStore';

/**
 * פקדי השיחה בסרגל העליון — השתקה והמתנה, רק בזמן שיחה.
 *
 * במסך התותח הסופטפון הצף מוסתר (הוא כיסה את הלידים והציע חייגן ידני
 * באמצע סבב), ולכן מה שנציג צריך תוך כדי שיחה חייב לשבת כאן, לצד "נתק":
 * להשתיק ולהחזיק. ענייה לשיחה נכנסת נשארת בחלון השיחה הנכנסת.
 */
export function CallControls() {
  const state = useSipStore((s) => s.state);
  const muted = useSipStore((s) => !!s.active?.muted);
  const mute = useSipStore((s) => s.mute);
  const hold = useSipStore((s) => s.hold);
  const unhold = useSipStore((s) => s.unhold);

  const onCall = state === 'on-call' || state === 'on-hold';
  if (!onCall) return null;

  const held = state === 'on-hold';
  const btn = (active: boolean): React.CSSProperties => ({
    display: 'inline-flex', alignItems: 'center', gap: 6,
    height: 32, padding: '0 12px', borderRadius: 'var(--r-pill)',
    border: '1px solid var(--line)', cursor: 'pointer', fontFamily: 'inherit',
    fontSize: 'var(--t-sm)', fontWeight: 600,
    background: active ? 'var(--warn-soft, #fff4e5)' : 'var(--surface)',
    color: active ? 'var(--warn, #b45309)' : 'var(--text)',
  });

  return (
    <>
      <button
        type="button"
        onClick={() => mute()}
        aria-label={muted ? 'בטל השתקה' : 'השתק'}
        aria-pressed={muted}
        title={muted ? 'המיקרופון מושתק — לחץ לבטל' : 'השתק את המיקרופון'}
        style={btn(muted)}
      >
        <Icon name="mic" size={15} />
        {muted ? 'מושתק' : 'השתק'}
      </button>
      <button
        type="button"
        onClick={() => (held ? unhold() : hold())}
        aria-label={held ? 'חזור לשיחה' : 'המתנה'}
        aria-pressed={held}
        title={held ? 'הלקוח בהמתנה — לחץ לחזור לשיחה' : 'העבר את הלקוח להמתנה'}
        style={btn(held)}
      >
        <Icon name={held ? 'play' : 'pause'} size={15} />
        {held ? 'בהמתנה' : 'המתנה'}
      </button>
    </>
  );
}
